import wood1 from '../assets/wood1.avif'
import wood2 from '../assets/wood2.avif'
import wood3 from '../assets/wood3.avif'
import wood4 from '../assets/wood4.avif'
import newitem1 from "../assets/newitem1.jpg"
export const demoProducts = [
    {
        _id: 'demo1',
        title: 'Beautiful Wooden Floors',
        description: 'Add warmth, elegance, and timeless beauty to your home with premium wooden floors. Whether youre renovating a single room or updating your entire home, wood flooring provides a stunning, durable, and versatile option that suits any décor. With its natural grain and rich textures, wood creates an inviting atmosphere while enhancing the overall aesthetic of your living space. Choose from a variety of styles, finishes, and wood types to find the perfect floor that suits your taste and lifestyle.',
        features: ['Solid wood', 'Ergonomic design'],
        image: { url: wood3 },
        price: 299
    },
    {
        _id: 'demo2',
        title: 'A Touch of Nature',
        description: 'Our collection of wooden furniture brings the perfect blend of craftsmanship and nature into your home. Whether your outfitting a living room or a study, our stunning wooden designs will seamlessly enhance the atmosphere with their elegance, durability, and timeless appeal.',
        features: ['Durable finish', 'Spacious design'],
        image: { url: wood2 },
        price: 899
    },
    {
        _id: 'demo3',
        title: 'Wooden House',
        description: 'A wooden house offers unparalleled warmth, charm, and sustainability. Crafted with nature’s most timeless material, a wooden home provides a serene, welcoming environment that blends rustic beauty with modern elegance. Whether youre looking for a cozy cabin, a luxurious lodge, or a contemporary wooden house, our expertly designed homes are perfect for those who appreciate the durability, aesthetic appeal, and eco-friendliness of wood. Experience the benefits of living in a home that’s not only beautiful but also harmonizes perfectly with the natural world around you.',
        features: ['Multiple compartments', 'Sturdy construction'],
        image: { url: wood1 },
        price: 599
    },
    {
        _id: 'demo4',
        title: 'Dream Wooden House',
        description: 'Experience the charm and sustainability of a wooden house, where nature meets modern living. Our wooden homes combine timeless craftsmanship with eco-friendly materials, offering a warm and inviting atmosphere. With custom design options, you can create a space that reflects your unique style while enjoying the many benefits of wood as a building material. Let the natural beauty of wood enhance your lifestyle with a home that’s as durable as it is beautiful.',
        features: ['Easy assembly', 'Modern design'],
        image: { url: wood4},
        price: 199
    },
    {
        _id: 'demo5',
        title: 'Bespoke Wooden ',
        description: ' Transform your home with Dhiman Wood Work, where craftsmanship meets creativity. Specializing in custom wooden interiors, we bring warmth, elegance, and sophistication to your living spaces. From intricately designed feature walls to premium furniture, our expert artisans craft timeless pieces tailored to your style. Experience luxury woodwork that blends functionality with artistic excellence. Let us redefine your interiors with the beauty of wood.',
        features: ['Ergonomic design', 'Durable finish'],
        image: { url: newitem1 },
        price: 149
    }
];